export default __webpack_public_path__ + "static/028-5bc96d80d3514fecafd8204782e4196d.png";